import React, { useEffect, useState } from "react";
import { Grid, Button, Paper, useMediaQuery, Box, Modal } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../../Utility/Utilitys";
 
import {
  common_LocationwiseStock_API, 
} from "../../../Server/ApiV2"; 
import {
  SalesInvoiceRo,
  StockAdjustmentRo,
  vRdxUserInfo,
} from "../../../Redux/roStore";

const GCLocationWiseStock = ({
  open = false,
  fCloseSearchModal = () => {},
  xTitle = "Locationwise Stock",
  xLabelItemName, 
  B_Itmcd,
  sLocationArr,
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  const [rows, setRows] = useState([]);
  const [Branch, setBr] = useState('');

  const handleLoad = async () => {
    await GetLoctionwiseStock(B_Itmcd);
    const { HeadObject } = StockAdjustmentRo();
    let iBr =
      sLocationArr.length > 0
        ? sLocationArr.find((item) => item.UId == HeadObject.A_FromLoc)
        : {};
        setBr(`${iBr?.Br || ""}  -  ${iBr?.BrName || ""}`)
  };

  useEffect(() => {
    if (open) {
      handleLoad();
    }
  }, [open]);
  const GetLoctionwiseStock = async (
    xItmCd
    // xBr,
    // setGridDataRows,
    // xUserCd
  ) => {
    const { HeadObject } = StockAdjustmentRo();
    const vRdxUserInfoObj = vRdxUserInfo();
    let iBr =
      sLocationArr.length > 0
        ? sLocationArr.find((item) => item.UId == HeadObject.A_FromLoc)
        : {};
    var vObj = {
      v_ItmCd: xItmCd,
      v_UserCd: vRdxUserInfoObj.UserID,
      v_Br: iBr?.Br || "",
    };
    const irow = await common_LocationwiseStock_API(vObj);
    if (irow?.status === 200) {
      let iRespRows = irow?.data?.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
    //   setRows(rows);
      // Calculate sums
      let totalStkQty = 0;
      let totalStkVal = 0;
      let totalPRQty = 0;
      let totalSOQty = 0;
      let totalDOQty = 0;
      let totalSIQty = 0;
      let totalTRFQty = 0;
      let totalADJQty = 0;
      let totalReserved = 0;
      let totalAvlQty = 0;
      let totalLiveSales = 0;
      const modifiedData = iRespRows.map((row) => {
        totalStkQty += row.StkQty || 0;
        totalStkVal += row.StkVal || 0;
        totalPRQty += row.PRQty || 0;
        totalSOQty += row.SOQty || 0;
        totalDOQty += row.DOQty || 0;
        totalSIQty += row.SIQty || 0;
        totalTRFQty += row.TRFQty || 0;
        totalADJQty += row.ADJQty || 0;
        totalReserved += row.Reserved || 0;
        totalAvlQty += row.AvlQty || 0;
        totalLiveSales += parseFloat(row.LiveSales) || 0;

        return {
          ...row,
        };
      });

      // // Add totals row
      const totalsRow = {
        id: modifiedData.length + 1,
        Location: "Total",
        StkQty: totalStkQty,
        StkVal: totalStkVal,
        SrNo: modifiedData.length + 1,
        Cost: "",
        ["LP.Rate"]: "",
        PRQty: totalPRQty,
        SOQty: totalSOQty,
        DOQty: totalDOQty,
        SIQty: totalSIQty,
        TRFQty: totalTRFQty,
        ADJQty: totalADJQty,
        Reserved: totalReserved,
        Loc: "",
        AvlQty: totalAvlQty,
        LiveSales: totalLiveSales,
        // assuming 'Cost' is a string
        // Add other properties if needed
      };

      modifiedData.length > 0 && modifiedData.push(totalsRow);
      setRows(modifiedData);
    //   return modifiedData;
    } else {
      setRows([]);
    //   return [];
    }
  };
  return (
    <Modal
      open={open}
      onClose={(e) => {
        setRows([]);
        fCloseSearchModal()
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ flexGrow: 1, overflow: "auto" }}
        className="
      gnr-item-search 
      model-gc-search"
      >
        <GCTitleSticky title={xTitle} onClose={(e) => {
        setRows([]);
        fCloseSearchModal()
      }} />

        <div className="p-2">
          <Grid
            container
            spacing={1}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className="mt-2 justify-content-between"
          >
            <Grid item xs={3}  md={2} className="gnr-item-search-label ">
              ItemName {""}
            </Grid>
            <Grid
              item
              xs={8} 
              md={10}
              className="gnr-item-search-label "
            >
              {xLabelItemName}
            </Grid>
            <Grid item xs={3}  md={2} className="gnr-item-search-label ">
              Branch
            </Grid>
            <Grid
              item
              xs={8} 
              md={10}
              className="gnr-item-search-label "
            >
              {Branch}
            </Grid>
          </Grid>
          <Grid container spacing={1} className="search-item ">
            <Grid item xs={12} className=" height-table-scroll" component="div">
              <div
                style={{
                  height: vMediaQuery ? "52vh" : "54vh",
                  width: "100%",
                }}
                id="table-main-grid-3"
                className="search-grid-table mt-2"
              >
                <Box style={{ height: "100%", width: "100%" }}>
                  <DataGrid
                    rowHeight={30}
                    headerHeight={40}
                    // getRowClassName={(params) =>
                    //   params.indexRelativeToCurrentPage % 2 === 0
                    //     ? "mui-even-row"
                    //     : "mui-odd-row"

                    // }
                    getRowClassName={(params) =>
                      `${
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "mui-even-row"
                          : "mui-odd-row"
                      } ${params.id === rows.length ? "mui-last-row" : ""}`
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                    }}
                    // rows={GridDataLocationwiseStockRows}
                    rows={rows}
                    columns={[
                      {
                        field: "Location",
                        headerName: "Location",
                        hide: false,
                        width: 170,
                        align: "left",
                        headerAlign: "left",
                        Typ: "S",
                        NumberFormat: "",
                      },
                      {
                        field: "StkQty",
                        headerName: "StkQty",
                        hide: false,
                        width: 60,
                        align: "right",
                        headerAlign: "right",
                        Typ: "N",
                        NumberFormat: "N2",
                      },
                      {
                        field: "StkVal",
                        headerName: "StkVal",
                        hide: false,
                        width: 80,
                        align: "right",
                        headerAlign: "right",
                        Typ: "N",
                        NumberFormat: "N2",
                      },
                      {
                        field: "SrNo",
                        headerName: "SrNo",
                        hide: true,
                        width: 60,
                        align: "right",
                        headerAlign: "right",
                        Typ: "N",
                        NumberFormat: "",
                      },
                      {
                        field: "Cost",
                        headerName: "Cost",
                        hide: false,
                        width: 60,
                        align: "right",
                        headerAlign: "right",
                        Typ: "N",
                        NumberFormat: "N2",
                      },
                      {
                        field: "LP.Rate",
                        headerName: "Rate",
                        hide: false,
                        width: 60,
                        align: "right",
                        headerAlign: "right",
                        Typ: "N",
                        NumberFormat: "N2",
                      },
                      {
                        field: "PRQty",
                        headerName: "PRQty",
                        hide: false,
                        width: 60,
                        align: "right",
                        headerAlign: "right",
                        Typ: "N",
                        NumberFormat: "N2",
                      },
                      {
                        field: "SOQty",
                        headerName: "SOQty",
                        hide: false,
                        width: 60,
                        align: "right",
                        headerAlign: "right",
                        Typ: "N",
                        NumberFormat: "N2",
                      },
                      {
                        field: "DOQty",
                        headerName: "DOQty",
                        hide: false,
                        width: 60,
                        align: "right",
                        headerAlign: "right",
                        Typ: "N",
                        NumberFormat: "N2",
                      },
                      {
                        field: "SIQty",
                        headerName: "SIQty",
                        hide: false,
                        width: 60,
                        align: "right",
                        headerAlign: "right",
                        Typ: "N",
                        NumberFormat: "N2",
                      },
                      {
                        field: "TRFQty",
                        headerName: "TRFQty",
                        hide: false,
                        width: 60,
                        align: "right",
                        headerAlign: "right",
                        Typ: "N",
                        NumberFormat: "N2",
                      },
                      {
                        field: "ADJQty",
                        headerName: "ADJQty",
                        hide: false,
                        width: 60,
                        align: "right",
                        headerAlign: "right",
                        Typ: "N",
                        NumberFormat: "N2",
                      },
                      {
                        field: "Reserved",
                        headerName: "Reserved",
                        hide: false,
                        width: 60,
                        align: "right",
                        headerAlign: "right",
                        Typ: "N",
                        NumberFormat: "N2",
                      },
                      {
                        field: "Loc",
                        headerName: "Loc",
                        hide: true,
                        width: 60,
                        align: "right",
                        headerAlign: "right",
                        Typ: "N",
                        NumberFormat: "",
                      },
                      {
                        field: "AvlQty",
                        headerName: "AvlQty",
                        hide: false,
                        width: 60,
                        align: "right",
                        headerAlign: "right",
                        Typ: "N",
                        NumberFormat: "N2",
                      },
                      {
                        field: "LiveSales",
                        headerName: "Live.Sales",
                        hide: false,
                        width: 60,
                        align: "right",
                        headerAlign: "right",
                        Typ: "N",
                        NumberFormat: "N2",
                      },
                      {
                        field: "id",
                        headerName: "id",
                        hide: false,
                        width: 40,
                        align: "right",
                        headerAlign: "right",
                        Typ: "N",
                        NumberFormat: "N2",
                      },
                    ]}
                    // getRowId={(row) => row.id}
                    hideFooter={rows.length < 100}
                    // components={{
                    //   Toolbar: GridToolbar,
                    // }}
                  />
                </Box>
              </div>
            </Grid>
          </Grid>
        </div>
      </Box>
    </Modal>
  );
};

export default GCLocationWiseStock;
